import { useSelector } from '@xstate/react'
import React, { useState } from 'react'
import styled from 'styled-components'
import { media } from 'utils/media'
import { Button as OriginalButton } from 'lib/Button/Button'
import { ModalPopupNew } from 'lib/ModalPopupNew'
import { Text } from 'lib/Text'
import { useSessionContext } from 'modules/auth/context/SessionProvider'
import { useCurrentUser } from 'modules/auth/useCurrentUser'
import { LevelUpAnimation } from 'modules/user/levels/components/LevelAnimation'
import { useWatchMeQuery } from '../queries/useWatchMeQuery'
import { LevelIcon } from './components/LevelIcon'
import { LevelUpCopies } from './components/LevelUpModalCopies'

const Button = styled(OriginalButton)`
  ${media.phoneDown} {
    width: 100%;
  }
`

const LevelBanner = styled.div`
  width: 100%;
  background: var(--neutral-5);
  max-height: 216px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`

const LevelCircle = styled.div`
  background: rgba(126, 197, 248, 0.2);
  width: 256px;
  height: 256px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const LevelUpModal = () => {
  const { user } = useCurrentUser()
  const { sessionService, setLevelUpModalVisible, levelUpModalVisible } = useSessionContext()
  const currentUserLevel = useSelector(sessionService, (state) => state.context.user?.level)
  const [memoizedLevel, setMemoizedLevel] = useState<number | undefined>(currentUserLevel)

  useWatchMeQuery((me) => {
    if (me) {
      /**
       * In the event that the user was not loaded server-side, but is logged in, memoizedLevel might not
       * be set yet.
       */
      if (!memoizedLevel) {
        setMemoizedLevel(me.level)
        return
      } else if (me.level !== memoizedLevel) {
        setMemoizedLevel(me.level)
        if (me.level > 0) {
          setLevelUpModalVisible(true)
        }
        return
      }
    }
  })

  if (!user) {
    return null
  }

  const handleClose = () => {
    setLevelUpModalVisible(false)
  }

  return (
    <ModalPopupNew
      title={`Welcome to level ${user.level}`}
      actions={<Button onClick={handleClose} color="primary" size="small" label="Done" />}
      open={levelUpModalVisible}
      onRequestClose={handleClose}
      mobileFullscreen>
      <div>
        <LevelUpAnimation level={user.level}>
          <LevelBanner>
            <LevelCircle>
              <LevelIcon level={user.level} size={124} />
            </LevelCircle>
          </LevelBanner>
          <Text size="m" as="h2" margin="1x">
            You reached level {user.level}
          </Text>

          <Text size="p">Thanks for contributing to Thingtesting, and welcome to level {user.level}!</Text>

          <LevelUpCopies
            karmaRequirementForNextLevel={user?.karmaRequirementForNextLevel || 0}
            karmaRequirementForPreviousLevel={user?.karmaRequirementForPreviousLevel || 0}
            level={user.level}
            karma={user.karma}
          />
        </LevelUpAnimation>
      </div>
    </ModalPopupNew>
  )
}
